import React, { useState } from 'react';
import { Card, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import HistoryPositions from './HistoryPositions';
import FilterSidebar from './FilterSidebar';

const History = () => {
    const [animationNavTab, setanimationNavTab] = useState("2");
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const animationNavToggle = (tab) => {
        if (animationNavTab !== tab) {
            setanimationNavTab(tab);
        }
    };

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen); // Toggle sidebar visibility
    };
    return (
        <>
            <Card className='bg-transparent mb-0'>
                <div className="d-flex justify-content-between align-items-center">
                    <Nav pills className="nav nav-pills animation-nav nav-justified gap-2 " style={{ borderRadius: "6px",}}>
                      {/*  <NavItem>
                            <NavLink style={{ cursor: "pointer" }} className={classnames({ active: animationNavTab === "1", })} onClick={() => { animationNavToggle("1"); }} >
                                Positions
                            </NavLink>
                        </NavItem>*/}
                        <NavItem>
                            <NavLink style={{ cursor: "pointer" }} className={classnames({ active: animationNavTab === "2", })} onClick={() => { animationNavToggle("2"); }} >
                                Orders
                            </NavLink>
                        </NavItem>
                       {/* <NavItem>
                            <NavLink style={{ cursor: "pointer" }} className={classnames({ active: animationNavTab === "3", })} onClick={() => { animationNavToggle("3"); }} >
                                Deals
                            </NavLink>
                        </NavItem>*/}

                    </Nav>
                    <span className='fs-4 d-flex align-items-center justify-content-center'
                        style={{ width: "35px", height: "35px", borderRadius: '5px' }}
                        onClick={toggleSidebar}
                        >
                        <i className="ri-filter-3-line"></i>
                    </span>
                </div>

            </Card>
            <TabContent activeTab={animationNavTab} className="text-muted">
                <TabPane tabId="1" id="animation-home">
                    <HistoryPositions />

                </TabPane>

                <TabPane tabId="2" id="animation-profile">
                    <HistoryPositions />

                </TabPane>

                <TabPane tabId="3" id="animation-messages" >
                    <HistoryPositions />

                </TabPane>


            </TabContent>


            <FilterSidebar 
                isOpen={isSidebarOpen} 
                toggleSidebar={toggleSidebar} 
            />
        </>
    )
}

export default History
